import { render, staticRenderFns } from "./LoginRecord.vue?vue&type=template&id=670c49ca&scoped=true"
import script from "./LoginRecord.vue?vue&type=script&lang=js"
export * from "./LoginRecord.vue?vue&type=script&lang=js"
import style0 from "./LoginRecord.vue?vue&type=style&index=0&id=670c49ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c49ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670c49ca')) {
      api.createRecord('670c49ca', component.options)
    } else {
      api.reload('670c49ca', component.options)
    }
    module.hot.accept("./LoginRecord.vue?vue&type=template&id=670c49ca&scoped=true", function () {
      api.rerender('670c49ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/Chart/LoginRecord.vue"
export default component.exports